"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./MarketingImpactCalculatorWrapper.css");

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _Propulator = _interopRequireDefault(require("../../../higher-order/Propulator"));

var _formatters = _interopRequireDefault(require("../../../util/formatters"));

var _classnames = _interopRequireDefault(require("classnames"));

var _EmployeeCalculator = _interopRequireDefault(require("./EmployeeCalculator"));

var _RewardsCalculatorInput = _interopRequireDefault(require("../../../components/charts/RewardsCalculatorInput"));

var _ContentItem = _interopRequireDefault(require("../../../shared/components/cms/ContentItem"));

var _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MarketingImpactCalculatorWrapper = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(MarketingImpactCalculatorWrapper, _React$Component);

  var _super = _createSuper(MarketingImpactCalculatorWrapper);

  function MarketingImpactCalculatorWrapper() {
    _classCallCheck(this, MarketingImpactCalculatorWrapper);

    return _super.apply(this, arguments);
  }

  _createClass(MarketingImpactCalculatorWrapper, [{
    key: "render",
    value: function render() {
      var enableLoanCustomization = this.props.enableLoanCustomization;
      var customizedLoanInterestLabelPronoun = enableLoanCustomization ? "Your" : "Typical";
      var stats = this.props.stats;
      var defaultCost = this.props.loan.balance + stats.defaultInterestPaid;
      var totalCost = this.props.loan.balance + stats.totalInterestPaid - stats.principalSavings;

      var formattedDefaultCost = _formatters.default.moneyWhole(defaultCost);

      var formattedTotalCost = _formatters.default.moneyWhole(totalCost);

      var calculatorInputClassNames = (0, _classnames.default)("calculator-input", {
        invalid: this.props.invalidMonthlyPayment
      });
      var loanInputClassNames = (0, _classnames.default)(calculatorInputClassNames, {
        "non-customizable": !enableLoanCustomization
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "marketing-impact-calculator-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        contentKey: "calculatorHeader",
        className: "section-header"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "marketing-row calculator-input-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "calculator-inputs"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(calculatorInputClassNames, "slp-plan-input")
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "extraPayment",
        className: "top-label"
      }, "SLP Contribution"), /*#__PURE__*/_react.default.createElement(_RewardsCalculatorInput.default, {
        inputKey: "extraPayment",
        min: 25,
        max: 600,
        value: this.props.extraPayment,
        formatString: "$0,0",
        eventName: "UPDATE_EXTRA_PAYMENT"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: loanInputClassNames
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "balance",
        className: "top-label"
      }, "Remaining Loan Balance"), /*#__PURE__*/_react.default.createElement(_RewardsCalculatorInput.default, {
        inputKey: "balance",
        min: 1,
        max: 200000,
        value: this.props.loan.balance,
        formatString: "$0,0",
        disabled: !enableLoanCustomization,
        eventName: "UPDATE_LOAN_AND_ESTIMATE_TERM"
      })), enableLoanCustomization && /*#__PURE__*/_react.default.createElement("div", {
        className: loanInputClassNames
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "monthlyPayment",
        className: "top-label"
      }, "Monthly Payment"), /*#__PURE__*/_react.default.createElement(_RewardsCalculatorInput.default, {
        inputKey: "monthlyPayment",
        min: 50,
        max: 5000,
        value: this.props.loan.monthlyPayment,
        formatString: "$0,0",
        eventName: "UPDATE_LOAN_AND_ESTIMATE_TERM"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: loanInputClassNames
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "rate",
        className: "top-label"
      }, customizedLoanInterestLabelPronoun, " Interest Rate (APR)"), /*#__PURE__*/_react.default.createElement(_RewardsCalculatorInput.default, {
        inputKey: "rate",
        min: 1,
        max: 25,
        value: this.props.loan.rate,
        percentage: true,
        disabled: !enableLoanCustomization,
        formatString: "0.00%",
        eventName: "UPDATE_LOAN_AND_ESTIMATE_TERM"
      })), !enableLoanCustomization && /*#__PURE__*/_react.default.createElement("div", {
        className: loanInputClassNames
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "term",
        className: "top-label"
      }, "Repayment Term"), /*#__PURE__*/_react.default.createElement(_RewardsCalculatorInput.default, {
        inputKey: "term",
        value: this.props.loan.term,
        yearsToMonths: true,
        min: 6,
        max: 240,
        eventName: "UPDATE_LOAN_AND_ESTIMATE_TERM",
        disabled: true,
        suffix: " years"
      }))), this.props.invalidMonthlyPayment && /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        contentKey: "invalidMonthlyPayment",
        className: "invalid-message"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("marketing-row", "calculator-row", {
          invalid: this.props.invalidMonthlyPayment
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "calculator-col"
      }, /*#__PURE__*/_react.default.createElement(_EmployeeCalculator.default, null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "total-col"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "total-box"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "header-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "header-label"
      }, "Without SLP Contributions"), /*#__PURE__*/_react.default.createElement("div", {
        className: "header-amount"
      }, formattedDefaultCost)), /*#__PURE__*/_react.default.createElement("div", {
        className: "bar-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "principal",
        style: {
          width: "".concat(this.props.loan.balance / defaultCost * 100, "%")
        }
      }, /*#__PURE__*/_react.default.createElement("label", null, "Principal"), /*#__PURE__*/_react.default.createElement("div", {
        className: "bar"
      }), /*#__PURE__*/_react.default.createElement("label", {
        className: "amount-label"
      }, _formatters.default.moneyWhole(this.props.loan.balance))), /*#__PURE__*/_react.default.createElement("div", {
        className: "interest",
        style: {
          width: "".concat(stats.defaultInterestPaid / defaultCost * 100, "%")
        }
      }, /*#__PURE__*/_react.default.createElement("label", null, "Int."), /*#__PURE__*/_react.default.createElement("div", {
        className: "bar"
      }), /*#__PURE__*/_react.default.createElement("label", {
        className: "amount-label"
      }, _formatters.default.moneyWhole(stats.defaultInterestPaid))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "total-box with-contributions"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "header-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "header-label"
      }, "With SLP Contributions"), /*#__PURE__*/_react.default.createElement("div", {
        className: "header-amount"
      }, formattedTotalCost)), /*#__PURE__*/_react.default.createElement("div", {
        className: "bar-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "slp",
        style: {
          width: "".concat(stats.principalSavings / defaultCost * 100, "%")
        }
      }, /*#__PURE__*/_react.default.createElement("label", null, "SLP"), /*#__PURE__*/_react.default.createElement("div", {
        className: "bar"
      }), /*#__PURE__*/_react.default.createElement("label", {
        className: "amount-label"
      }, _formatters.default.moneyWhole(stats.principalSavings))), /*#__PURE__*/_react.default.createElement("div", {
        className: "interest",
        style: {
          width: "".concat(stats.totalInterestPaid / defaultCost * 100, "%")
        }
      }, /*#__PURE__*/_react.default.createElement("label", null, "Int."), /*#__PURE__*/_react.default.createElement("div", {
        className: "bar"
      }), /*#__PURE__*/_react.default.createElement("label", {
        className: "amount-label"
      }, _formatters.default.moneyWhole(stats.totalInterestPaid))), /*#__PURE__*/_react.default.createElement("div", {
        className: "principal",
        style: {
          width: "".concat((this.props.loan.balance - stats.principalSavings) / defaultCost * 100, "%")
        }
      }, /*#__PURE__*/_react.default.createElement("label", null, "Principal"), /*#__PURE__*/_react.default.createElement("div", {
        className: "bar"
      }), /*#__PURE__*/_react.default.createElement("label", {
        className: "amount-label"
      }, _formatters.default.moneyWhole(this.props.loan.balance - stats.principalSavings))))))));
    }
  }]);

  return MarketingImpactCalculatorWrapper;
}(_react.default.Component)) || _class;

var _default = (0, _Propulator.default)(MarketingImpactCalculatorWrapper, {
  impactCalculatorStore: ["loan", "extraPayment", "stats", "invalidMonthlyPayment"]
});

exports.default = _default;